var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 1.5,
    width: 29,
    height: 5,
    rx: 0.5,
    fill: "#146EE6",
    stroke: "#146EE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 29,
    height: 5,
    rx: 0.5,
    fill: "#146EE6",
    stroke: "#146EE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 17.5,
    width: 29,
    height: 5,
    rx: 0.5,
    fill: "#146EE6",
    stroke: "#146EE6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 25.5,
    width: 29,
    height: 5,
    rx: 0.5,
    fill: "#146EE6",
    stroke: "#146EE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12109 2.12122L6.36373 6.36386",
    stroke: "#146EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12109 6.36414L6.36373 2.1215",
    stroke: "#146EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12109 10.1212L6.36373 14.3639",
    stroke: "#146EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12109 14.3641L6.36373 10.1215",
    stroke: "#146EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12109 18.1212L6.36373 22.3639",
    stroke: "#146EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12109 22.3641L6.36373 18.1215",
    stroke: "#146EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12109 26.1212L6.36373 30.3639",
    stroke: "#146EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12109 30.3641L6.36373 26.1215",
    stroke: "#146EE6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNotFound);
export default __webpack_public_path__ + "static/media/list-not-found.e643698fe52e73181561709741aa2358.svg";
export { ForwardRef as ReactComponent };